import React, { useState } from "react";
import { Link } from "react-router-dom";
import CartEditPopup from "./CartEditPopup";
import { useDispatch } from "react-redux";
import { postApiAction, getSiteId } from "../../Utils/helper";
import { decrementCartCount, incrementCartCount } from "../../store/action";
import { BASE_URL } from '../../constants';

const CartItems = ({ item }) => {
    const [quantity, setQuantity] = useState(item.quantity);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [comment, setComment] = useState(item.notes);
    const dispatch = useDispatch();

    const handleOpenPopup = () => {
      setIsPopupOpen(true);
    };
  
    const handleClosePopup = () => {
      setIsPopupOpen(false);
    };

  const incrementQuantity = async () => {
    setQuantity(quantity + 1);
    let postData = {
      product_id: item.product.id,
      quantity: quantity + 1,
      notes: comment
    }
    let resp = await postApiAction("cart/update", postData, 0, dispatch);
    dispatch(incrementCartCount());

  };

  const decrementQuantity = async () => {
    if (quantity > 0) {
      setQuantity(quantity - 1);
      let postData = {
        product_id: item.product.id,
        quantity: quantity - 1,
        notes: comment
      }
      let resp = await postApiAction("cart/update", postData,  0, dispatch);
      dispatch(decrementCartCount());
    }
  };

  const updateComment = (newComment) => {
    setComment(newComment);
    item.notes = comment
  };


  return (
    <>
      {quantity > 0 &&
      
      <div className="breakfast_item">
        <div className="sub_breakfast">
          <div className="number">
            <span className="plus" onClick={incrementQuantity}>
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M21.5 12.5L12.5 12.5L12.5 21.5H9.5L9.5 12.5L0.5 12.5L0.5 9.5L9.5 9.5L9.5 0.5L12.5 0.5L12.5 9.5L21.5 9.5V12.5Z" fill="#3D3935"/>
            </svg>
            </span>
            <input type="text" value={quantity} />
            <span className="minus" onClick={decrementQuantity}>
              {
                quantity > 1 ? 
                <svg  xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 20 20" fill="none">
                <path d="M4.16699 10.8337H15.8337V9.16699H4.16699V10.8337Z" fill="#3D3935"/>
              </svg>
              :
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 13.5L24 28.5L12 28.5L12 13.5L24 13.5ZM21.75 4.5L14.25 4.5L12.75 6L7.5 6L7.5 9L28.5 9V6L23.25 6L21.75 4.5ZM27 10.5L9 10.5L9 28.5C9 30.15 10.35 31.5 12 31.5L24 31.5C25.65 31.5 27 30.15 27 28.5L27 10.5Z" fill="#3D3935"/>
                </svg>
              }
              
            </span>
          </div>
          <div className="breakfastBox">
            <Link to={`/${getSiteId()}/products/details/${item?.product?.id}`}>
              <div className="image">
                <img src={item.product.default_image} alt="" />
              </div>
            </Link>
            <div className="text">
              <Link to={`/${getSiteId()}/products/details/${item?.product?.id}`}>
                <h4>{item.product.name}</h4>
              </Link>
              {(item.attribute) ? (
                <p>{item?.attribute?.name} {item?.attribute?.modifier_options.map((option) =>
                <>
                {(option.productModifierID == item.modifier_id) ? (
                  <>
                  - {option.optionName}
                  </>
                ) : (<></>)}
                </>
                )}</p>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="right">
            <span className="dollar_value">
              ${((Math.round(item.sub_total * 100) / 100).toFixed(2)).split(".")[0]}
              <sup>{((Math.round(item.sub_total * 100) / 100).toFixed(2)).split(".")[1]}</sup>
            </span>
            <button onClick={handleOpenPopup} className="edit_icn">
              <img src={`${BASE_URL}/assets/images/edit2.png`} alt="" />
            </button>
          </div>
        </div>

  {isPopupOpen && 
        <CartEditPopup cartData={item} onClose={handleClosePopup} onUpdateComment={updateComment}/>
      }
      </div>
    }
    </>
  );
};

export default CartItems;
